export default "__VITE_ASSET__CsXaInAy__"